/*
 * @Author: DQL
 * @Date: 2020-03-20 11:18:19
 * @LastEditors: DQL
 * @LastEditTime: 2023-04-17 14:50:04
 * @Description: file content
 */

/* =============================================
   业务功能路由配置文件引入 Start
  *
  *
*/

// 机构部门维护
import deptRoutes from '@/features/systemManage/dept/dept.routes.js';

// 用户维护
import userRoutes from '@/features/systemManage/user/user.routes.js';

// 机构用户管理
import accountRoutes from '@/features/systemManage/account/account.routes.js';

// 工程师管理
import gcsRoutes from '@/features/systemManage/gcs/gcs.routes.js';

/* 业务功能路由配置文件引入 End */

/* =============================================
   业务功能路由配置写入 Start
  *
  *
*/
const FEATURES_ROUTES = [...userRoutes, deptRoutes, accountRoutes, gcsRoutes];

/* 业务功能路由配置写入 End */

// 路由配置=============================================
const systemManageRoutes = {
  path: 'systemManage',
  name: 'systemManage',
  component: { template: '<router-view></router-view>' },
  children: [...FEATURES_ROUTES]
};

export default systemManageRoutes;
